import i18nData from './editor/i18nData';
import i18nDataAlex from './alex/i18nData';
import i18nDataEmotionhack from './emotionhack/i18nData';

// en, de, fr, pt
export default {
  en: {
    editor: i18nData.en,
    alex: i18nDataAlex.en,
    emotionhack: i18nDataEmotionhack.en
  },
  de: {
    editor: i18nData.de,
    alex: i18nDataAlex.de,
    emotionhack: i18nDataEmotionhack.de
  },
  fr: {
    editor: i18nData.fr,
    alex: i18nDataAlex.fr,
    emotionhack: i18nDataEmotionhack.fr
  },
  pt: {
    editor: i18nData.pt,
    alex: i18nDataAlex.pt,
    emotionhack: i18nDataEmotionhack.en
  },
  es: { // Spanish
    editor: i18nData.es,
    alex: i18nDataAlex.es,
    emotionhack: i18nDataEmotionhack.es
  },
  nl: { // Dutch
    editor: i18nData.nl,
    alex: i18nDataAlex.nl,
    emotionhack: i18nDataEmotionhack.nl
  },
  it: { // Italian
    editor: i18nData.it,
    alex: i18nDataAlex.it,
    emotionhack: i18nDataEmotionhack.it
  }
}
